import { render } from "./CustomLabel.vue?vue&type=template&id=7e68ea6e&scoped=true"
import script from "./CustomLabel.vue?vue&type=script&lang=js"
export * from "./CustomLabel.vue?vue&type=script&lang=js"

import "./CustomLabel.vue?vue&type=style&index=0&id=7e68ea6e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e68ea6e"]])

export default __exports__